import { convertObjectNumbers } from 'Shared/Utils/Extensions/String/StringExtensions';
import { AxiosResponse } from 'axios';

import { apiInstanceType, onErrorType, onResultType, requestConfigType } from '../Contracts/types';
import TrimJson from '../Utils/TrimJson';
import { ShowResponseError } from '../Utils/showResponseError';

export interface IHttpPostServiceProps {
  url: string;
  body?: object;
  onResult?: onResultType;
  onError?: onErrorType;
  config?: requestConfigType;
}

interface IProps extends IHttpPostServiceProps {
  API: apiInstanceType;
}

export const HttpPostService = async (props: IProps) => {
  if (props.onResult === undefined) {
    props.onResult = (res: AxiosResponse<any, any>): any => {
      if (res.status === 201 || res.status === 200) {
        return res.data;
      }
    };
  }
  if (props.onError === undefined) {
    props.onError = (error: any) => {
      ShowResponseError(error);
    };
  }

  try {
    const body = convertObjectNumbers(TrimJson(props.body));
    const response = await props.API.post(props.url, body, props.config).then(props.onResult).catch(props.onError);
    return response;
  } catch (error) {
    ShowResponseError(error);
  }
};
